import { useGetSchoolsQuery } from 'Services/ControlDataManagement/Features/School/schoolApi'
import type { FetchSchoolListParams } from 'Services/ControlDataManagement/Features/School/types'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_SCHOOL_PARAMETER_KEY = 'selectedSchool'

function useSchoolsWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [searchQueryParams, setSearchQueryParams] = useState<FetchSchoolListParams>({
    sort_by: searchParams.get('sort_by') ?? 'id',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    codespace_id: searchParams.get('codespace_id') ?? undefined,
    school_id: searchParams.get('school_id') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT
  })

  const {
    data: { resources: schools } = { resources: [] },
    data: { total_results: totalResults } = { total_results: 0 },
    isFetching
  } = useGetSchoolsQuery(searchQueryParams)

  const selectedSchoolQueryParam = searchParams.get(SELECTED_SCHOOL_PARAMETER_KEY) ?? undefined
  const [selectedSchoolId, setSelectedSchoolId] = useState(selectedSchoolQueryParam)

  const setQueryParams = () => {
    Object.entries(searchQueryParams).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    selectedSchoolId && searchParams.set(SELECTED_SCHOOL_PARAMETER_KEY, selectedSchoolId)
    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [searchQueryParams])

  useEffect(() => {
    if (selectedSchoolId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_SCHOOL_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedSchoolId])

  return {
    schools,
    isFetching,
    totalResults,
    searchQueryParams,
    setSearchQueryParams,
    selectedSchoolId,
    setSelectedSchoolId
  }
}

export default useSchoolsWithParams
